import { iHotTypeGame, iHotTypeGameSearch } from '@/interface/hot-game';
import request from '@/utils/request';
import { log } from 'console';

/* 新增热门游戏类别 */
export const postAddHotGameType = (data: iHotTypeGame): Promise<any> =>
  request({
    url: '/api/v1/omc/game/hot/kind',
    method: 'post',
    data,
  });
/* 修改热门游戏类别 */
export const updateHotGameType = (data: iHotTypeGame): Promise<any> =>
  request({
    url: '/api/v1/omc/game/hot/kind',
    method: 'put',
    data,
  });
/* 游戏热门类别列表 */
export const getHotGameTypeList = (params: any): Promise<any> =>
  request({
    url: '/api/v1/omc/game/hot/kind',
    params,
  });

/**
 * 删除游戏类型
 * @param params
 */
export const delHotGameType = (data: any): Promise<any> =>
  request({
    url: `/api/v1/omc/game/hot/kind?id=${data.id}&version=${data.version}`,
    method: 'delete',
  });

/**
 * 热门游戏类型排序
 * @param params
 */
export const setHotGameTypeSort = (data: any): Promise<any> =>
  request({
    url: '/api/v1/omc/game/hot/kind/sort',
    method: 'put',
    data,
  });
